import { getByType } from 'utils/stuff.js'
import * as R from 'ramda'
let properties = state => getByType(state, 'property')
let leases = state => getByType(state, 'lease')
let tenants = state => getByType(state, 'tenant')




let exLandlord = state => landlord => ({
	...landlord
  ,	properties: (landlord.propertiesIDs && landlord.propertiesIDs.length && R.values(properties(state)).length)?
		R.map(propID => properties(state)[propID], landlord.propertiesIDs) : undefined
  , leases:(landlord.propertiesIDs && landlord.propertiesIDs.length && R.values(properties(state)).length)?
		R.map(
			leaseID => leases(state)[leaseID]
		  , R.map(propID => R.prop('leaseID', properties(state)[propID])
					, landlord.propertiesIDs
			)
		)
	: undefined
  , tenants: (landlord.propertiesIDs && landlord.propertiesIDs.length && R.values(properties(state)).length)?
		R.reject((tenant) => !tenant
			,R.map(
				tenant => tenants(state)[tenant] || undefined
				  , R.map(
			  			leaseID => (leaseID && leases(state)[leaseID])?R.prop('tenantID', leases(state)[leaseID]) : undefined
			  		  	, R.map(propID => R.prop('leaseID', properties(state)[propID])
			  					, landlord.propertiesIDs)
		  			)
			)
		)
	: undefined
})
export default (state) => R.map(landlord => exLandlord(state)(landlord), getByType(state, 'landlord'))



// WEBPACK FOOTER //
// ./src/selectors/landlords.js